// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"390069c7","239":"f129f2bb","453":"e0914802","455":"26725f97"}[chunkId] + ".chunk.js";
};